import React from "react";

const LimitOrderDocs = (
    <>
        <p>
            place a limit order once the setup has been achieved.
        </p>
        params:
        <p>
            <b>offset from Price:</b> The Offset from the price at the time of the break. If long and break
            occurred at 1, and the offset is 10%, the limit order will be placed 1.1. If short, it will be placed at .9.
        </p>
        <p>
            <b>QuantityBasisValue:</b> the amount you'd like to invest based on the QuantityBasis (dollars,
            quantity) that you chose. So if you would like to make an investment of max 1000$, the quantity basis would
            be dollars, and the quantityBasisValue would be 1000$.
            Similarly, if QuantityBasis of Quantity was chosen, and you'd like to buy 5 contracts/shares, this param
            would be set to 5.
        </p>
        <b>limitPrice:</b> A hard limit price to purchase at. If you put in 1.05, the limit price on the entry order
        will
        be 1.05. NOTE: this setting overrides "offset from price". If both fields are filled out, this field will take
        precedence. Additionally, this tactic should only be used if you are confident you know what the correct price
        will be.
        <p>
        </p>
        {/*     <p>
            <b>set limit from setup:</b> Whether to set the limit price based on price to break of the setup, or from
            the currentPrice. Ex: lets say your break setup had a price to break of 100, and the current price was
            100.02. If this field is checked, then the limit will be set at 100. If it is not checked, the limit will be
            set at 100.02.
        </p>
        <p>
            NOTE: the field: "set limit from setup" cannot be checked if the setup is AD_HOC, or the instrument is
            option. In the case of AD_HOC, there is not trigger price broken for the setup. For options, the break of
            the setup, which tracks the underlying, is not relevant to the option
        </p>*/}
    </>
);

export default LimitOrderDocs;
